import React from 'react';

const LoadingSpinner = ({ size = 'h-12 w-12', message = '' }) => {
    return (
        <div className="flex flex-col items-center justify-center p-8">
            <div className={`loader ease-linear rounded-full border-4 border-t-4 border-gray-600 ${size} mb-4`}></div>
            {message && <p className="text-white text-lg">{message}</p>}
        </div>
    );
};

export default LoadingSpinner;
